import { gql } from "@apollo/client";

export const REMOVE_ORGANIZATION_MEMBERSHIP = gql`
  mutation RemoveOrganizationMembership(
    $input: RemoveOrganizationMembershipInput!
  ) {
    removeOrganizationMembership(input: $input)
  }
`;
